import Component from '../abstracts/Component';

export default class DataLinkComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-link]',
      cta: 'a',
      showMore: 'button.show-more',
      video: '.jw-icon-display,.brightcove-wrapper',
      afterLink: 'after-link'
    };
  }


  constructor() {
    super();
  }


  linkManager(el) {

    let self = el;
    let url = self.data('link');
    let target = self.data('linkTarget');
    let external = target == '_blank' || target == 'external';

    if (self.data("linkDisabled")) {
      return;
    }

    if ( $('body').is('.editmode') ) {
      return;
    }

    if (url.match(/^#/) != null) {
      if(url == '#') {
        window.location.href = url;
      }
      return;
    }

    let $showMore = $(el).find(this.SELECTORS.showMore);
    let $afterIsLink = $(el).hasClass(this.SELECTORS.afterLink);
    if (this.$matchMedia('sm', null) && $showMore.length > 0) {
      if(!$afterIsLink) {
        return;
      }
    }

    let $video = $(el).find(this.SELECTORS.video);
    if ($video.length > 0) {
      return;
    }

    if (external) {
      window.open(url, '_blank', 'noopener noreferrer');
    } else {
      window.location.href = url;
    }

    console.log("leading to: ", url);

  }

  bindEvents() {

    this.unbindEvents();

    let links = document.querySelectorAll(this.SELECTORS.main);

    links.forEach(el => {
      let cta = el.querySelector(this.SELECTORS.cta);
      let $showMore = $(el).find(this.SELECTORS.showMore);

      if (this.$matchMedia('sm', null) && !$showMore) {
        $(cta).on('click.cta', function (e) {
          e.preventDefault();
        })
      }

      this.$on('click.dataLink', ({event}) => {
        let empty = $(el).data('link');

        if( empty != '' ) {
          this.linkManager($(event.currentTarget));
        }
      }, el);

    })

  }

  unbindEvents() {

    let links = document.querySelectorAll(this.SELECTORS.main);

    links.forEach(el => {
      let cta = el.querySelector(this.SELECTORS.cta);
      $(cta).off('click.data-link')
      $(el).off('click.data-link');
    })

  }

  render() {
    if( document.querySelector(this.SELECTORS.main) ) this.bindEvents();
  }
}
